<template>
    <div>
        <div v-if="showAlert">
            <div class="alert alert-danger rounded-0 mb-0 text-center" v-if="daysPassed(0)">
                <span>
                    Sua assinatura está atrasada há {{ Math.round(daysPassed(0)) }} {{ Math.round(daysPassed(0))>1 ? 'dias' : 'dia' }}
                </span>
                <a :href="information.endpoint_asaas" class="btn btn-sm ml-2 btn-primary">
                    Verificar assinatura
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['information'],
    data(){
        return {

        }
    },
    created(){
    },
    computed :{
        showAlert(){
            return !! this.information.is_owner && this.information.can_show && this.information.payments[0].status === 'OVERDUE'
        },
        payments(){
            return this.information.payments
        }
    },
    methods: {
        daysPassed(days) {
            const today = new Date()
            
            if (this.payments[0].dueDate) {
                const dueDate = new Date(this.payments[0].dueDate)
                const daysPassed = (today - dueDate) / (1000 * 60 * 60 * 24)

                if (daysPassed > days) {
                    return daysPassed
                }

                return false
            }

        }
    }
}
</script>

<style>

</style>
